var map = {
	"./afb-color.svg": 651,
	"./alb-color.svg": 652,
	"./all.svg": 653,
	"./amb-color.svg": 654,
	"./arg.svg": 655,
	"./aus.svg": 656,
	"./bank-icon.svg": 657,
	"./bankdemo-color.svg": 658,
	"./bel.svg": 659,
	"./bimb-color.svg": 660,
	"./bkr-color.svg": 661,
	"./bpay-color.svg": 662,
	"./bra.svg": 663,
	"./bsn-color.svg": 664,
	"./can.svg": 665,
	"./checked-blue.webp": 1556,
	"./checked-green.png": 666,
	"./checked-white.png": 667,
	"./cimb-color.svg": 668,
	"./cimb-icon.svg": 669,
	"./citi-color.svg": 670,
	"./cmr.svg": 671,
	"./crc.svg": 672,
	"./cro.svg": 673,
	"./den.svg": 674,
	"./ecu.svg": 675,
	"./eng.svg": 676,
	"./esp.svg": 677,
	"./fav-blue.svg": 678,
	"./fav-blue.webp": 1557,
	"./fav-gray.png": 679,
	"./fav-gray.svg": 680,
	"./fav-gray.webp": 1558,
	"./fav-icon-active.png": 681,
	"./fav-icon.png": 682,
	"./fav-red.png": 683,
	"./fra.svg": 684,
	"./game-icon.svg": 685,
	"./games-active-m.svg": 686,
	"./games-m.webp": 1559,
	"./ger.svg": 687,
	"./gha.svg": 688,
	"./gxbank-color.svg": 689,
	"./hlb-color.svg": 690,
	"./hlb-icon.svg": 691,
	"./hsbc-color.svg": 692,
	"./irn.svg": 693,
	"./jpn.svg": 694,
	"./kor.svg": 695,
	"./ksa.svg": 696,
	"./kwh-color.svg": 697,
	"./latest-icon-active.png": 698,
	"./latest-icon.png": 699,
	"./lc-active-m.svg": 700,
	"./lc-icon.svg": 701,
	"./lc-m.webp": 1560,
	"./lottery-active-m.svg": 702,
	"./lottery-icon.svg": 703,
	"./lottery-m.svg": 704,
	"./love.svg": 705,
	"./mar.svg": 706,
	"./mbb-color.svg": 707,
	"./mex.svg": 708,
	"./ned.svg": 709,
	"./ocbc-color.svg": 710,
	"./ocbc-icon.svg": 711,
	"./p2p-active-m.svg": 712,
	"./p2p-icon.svg": 713,
	"./p2p-m.svg": 714,
	"./pbb-color.svg": 715,
	"./pol.svg": 716,
	"./por.svg": 717,
	"./price-high.svg": 718,
	"./price-low.svg": 719,
	"./qat.svg": 720,
	"./rhb-color.svg": 721,
	"./rhb-icon.svg": 722,
	"./scb-color.svg": 723,
	"./sen.svg": 724,
	"./slot-active-m.svg": 725,
	"./slot-icon.svg": 726,
	"./slot-m.webp": 1561,
	"./sport-active-m.svg": 727,
	"./sport-m.webp": 1562,
	"./sports-icon.svg": 728,
	"./srb.svg": 729,
	"./star.svg": 730,
	"./sui.svg": 731,
	"./tng-color.svg": 732,
	"./trx-icon.svg": 733,
	"./trx.svg": 734,
	"./tun.svg": 735,
	"./uob-color.svg": 736,
	"./uru.svg": 737,
	"./usa.svg": 738,
	"./usdc.svg": 739,
	"./usdt.svg": 740,
	"./ustd-icon.svg": 741,
	"./wal.svg": 742,
	"./x33-logo-b.svg": 743,
	"./x33-square-icon.svg": 744
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 439;